export default __webpack_public_path__ + "media/images/mail/linkedin-3824847c14912cd048dc368fce2d0556.png";